/**************************************************
 * Nombre:       Tarjeta_Pasos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {COLORTEXTO, NEGRITA} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Pasos = ({item, index}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={sCell ? 'flex-start' : 'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: 'white',
                borderRadius: 6,
                p: 6
            }}
        >

            <Grid container size={{xs: 2, sm: 2, md: 2}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: sCell ? 32 : 48, color: theme.palette.primary.main, fontWeight: 600,ml: -4}}>{index+1}</Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 10, sm: 10, md: 10}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: !masSM ? 24 : 30, color: theme.palette.primary.main, fontWeight: 800, lineHeight: 1.1}}>
                        {item.nombre}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',pr: 2,mt: 1}}>
                    <Typography sx={{fontSize: 18, color: COLORTEXTO, fontFamily: NEGRITA, lineHeight: 1.2}}>
                        {item.descripcion}
                    </Typography>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Tarjeta_Pasos    